<template>
  <div class="orderPage">
    <div class="search_wrap flex-between">
      <van-field v-model="params.order_id" placeholder="输入订单号查找→" />
      <div class="search_btn flex-rowc" @click="handleSearch">
        <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div>
    <div class="select_wrap">
      <!-- <div class="select_item flex-between" @click="handleShow(1)">
        <span>{{ orserState }}</span>
        <i class="iconfont icon-toTop"></i>
      </div>
      <div class="select_item flex-between" @click="handleShow(2)">
        <span>{{ orderProperty }}</span>
        <i class="iconfont icon-toTop"></i>
      </div> -->
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="params.service_order_status"
          :options="serviceOrderState"
          @change="changeDropdownStatus"
        />
        <van-dropdown-item
          v-model="params.service_order_property"
          :options="serviceOrderProperty"
          @change="changeDropdownProperty"
        />
      </van-dropdown-menu>
    </div>
    <div class="flex-between">
      <div class="radio_wrap flex-rowc">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#ee0a24"
          @change="changeCheck"
        ></van-checkbox>
        <span>按筛选条件只看今天的订单</span>
      </div>
      <div class="clear_condition" @click="handleClearParams">
        清空筛选条件
        <!-- 清空筛选条件（显示所有订单） -->
      </div>
    </div>

    <div class="order_wrap" @scroll="orderScroll($event)">
      <div class="list" v-if="dataList.length > 0" >
        <div class="item" v-for="item in dataList" :key="item.id" @click="handleDetail(item.order_id)">
          <div class="block_one">
            <div class="column flex-rowl">
              <p class="label">创建时间：</p>
              <p class="con">{{ getTiemSplit(item.create_time) }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">订单状态：</p>
              <p class="con">
                {{
                  item.service_order_status == 1
                    ? "待接单"
                    : item.service_order_status == 2
                    ? "已接单"
                    : item.service_order_status == 3
                    ? "取餐中"
                    : item.service_order_status == 4
                    ? "送餐中"
                    : item.service_order_status == 5
                    ? "待自提"
                    : item.service_order_status == 6
                    ? "已送达"
                    : "已完成"
                }}
              </p>
            </div>
            <div class="column flex-rowl">
              <p class="label">订单情况：</p>
              <p class="con">
                {{
                  item.service_order_property == 1
                    ? "服务订单进行中"
                    : item.service_order_property == 2
                    ? "服务订单取消申请中"
                    : item.service_order_property == 3
                    ? "服务订单已取消"
                    : "服务订单已完成"
                }}
              </p>
            </div>
          </div>
          <div class="block_two">
            <div class="column flex-between">
              <div class="left flex-rowl">
                <p class="label">服务订单号：</p>
                <p class="con">
                  {{ item.service_order_id }}
                </p>
              </div>
              <div
                class="btn_copy code"
                :data-clipboard-text="item.service_order_id"
                @click="handleCopy()"
              >
                <i class="iconfont icon-fuzhi"></i>
              </div>
            </div>
            <div class="column flex-between">
              <div class="left flex-rowl">
                <p class="label">订单号：</p>
                <p class="con">
                  {{ item.order_id }}
                </p>
              </div>
              <div
                class="btn_copy code"
                :data-clipboard-text="item.order_id"
                @click="handleCopy()"
              >
                <i class="iconfont icon-fuzhi"></i>
              </div>
            </div>
            <div class="column flex-rowl">
              <p class="label">送餐位置：</p>
              <p class="con">{{ item.address_detail }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">关联取餐柜：</p>
              <p class="con">{{ item.service_rating }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">用户姓名：</p>
              <p class="con">{{ item.truename }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">联系电话：</p>
              <p class="con">{{ item.customer_phone }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">订单内容：</p>
              <p class="con">{{ item.order_content }}</p>
            </div>
          </div>
          
        </div>
      </div>
      <van-empty
        description="暂无订单"
        v-if="!isLoading && dataList.length == 0"
      />
    </div>

    <!-- <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <template v-if="orderType == 1">
        <van-picker
          title="选择服务订单状态"
          show-toolbar
          @cancel="show = false"
          :columns="serviceOrderState"
          @confirm="onConfirmState"
        />
      </template>
      <template v-if="orderType == 2">
        <van-picker
          title="选择服务订单属性"
          show-toolbar
          @cancel="show = false"
          :columns="serviceOrderProperty"
          @confirm="onConfirmProperty"
        />
      </template>
    </van-popup> -->
  </div>
</template>

<script>
import { getOrderList, getToken } from "../api/api";
import Clipboard from "clipboard";

export default {
  name: "orderList",
  data() {
    return {
      show: false,
      // 服务订单状态
      serviceOrderState: [
        {
          text: "所有状态订单",
          value: "",
        },
        {
          text: "待接单",
          value: 1,
        },
        {
          text: "已接单",
          value: 2,
        },
        {
          text: "已取餐",
          value: 3,
        },
        {
          text: "送餐中",
          value: 4,
        },
        {
          text: "待自提（已放入餐柜）",
          value: 5,
        },
        {
          text: "已送达（直达）",
          value: 6,
        },
        {
          text: "已完成",
          value: 7,
        },
      ],
      // 服务订单属性
      serviceOrderProperty: [
        {
          text: "所有情况订单",
          value: "",
        },
        {
          text: "服务订单进行中",
          value: 1,
        },
        {
          text: "服务订单已取消（已退款）",
          value: 2,
        },
        {
          text: "服务订单已取消",
          value: 3,
        },
        {
          text: "服务订单已完成",
          value: 4,
        },
      ],

      checked: true,
      orderType: 1,
      orserState: "所有状态订单",
      orderProperty: "所有情况订单",
      params: {
        Page: 1,
        token: "",
        PageSize: 10,
        order_id: "",
        service_order_status: "",
        service_order_property: "",
        istoday: 1, // 1 是 0 否
      },

      isLoading: true,
      total: 0,
      dataList: [],
    };
  },
  created() {
    this.getToken();
  },
  computed: {
    getTiemSplit() {
      return function (data) {
        // let newData = data.split('T')[0] + ' ' + data.split('T')[1]
        let newData = data.replace("T", " ");
        return newData;
      };
    },
  },
  methods: {
    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getOrderList();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    //
    getOrderList() {
      let { params } = this;
      getOrderList(params).then((res) => {
        if (res.error_code == 0) {
          this.total = res.data.total;
          this.dataList = this.dataList.concat(...res.data.list);
          this.isLoading = false;
        } else {
          this.dataList = [];
        }
      });
    },

    // 滚动事件
    orderScroll(e) {
      let el = e.target;
      //判断是否到达div容器底部
      let { total, dataList } = this;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
        if (total > dataList.length) {
          this.params.Page += 1;
          this.getOrderList();
        }
      }
    },
    handleShow(type) {
      this.orderType = type;
      this.show = true;
    },
    handleSearch() {
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeCheck(e) {
      this.params.istoday = e ? 1 : 0;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownStatus(e) {
      console.log(e, "=========");
      this.params.service_order_status = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownProperty(e) {
      console.log(e, "=========");
      this.params.service_order_property = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    // onConfirmState(e) {
    //   let { text, value } = e;
    //   this.orserState = text;
    //   this.params.service_order_status = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    // onConfirmProperty(e) {
    //   let { text, value } = e;
    //   this.orderProperty = text;
    //   this.params.service_order_property = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    handleClearParams() {
      this.params.order_id = "";
      this.params.service_order_status = "";
      this.params.service_order_property = "";
      (this.orserState = "所有状态订单"),
        (this.orderProperty = "所有情况订单"),
        (this.params.istoday = 0);
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    /**
     * 复制功能
     */
    handleCopy() {
      var clipboard = new Clipboard(".code");
      console.log(clipboard, "=====clipboard");
      clipboard.on("success", (e) => {
        console.log("复制成功", e);
        this.$toast({
          message: "复制成功",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast({
          message: "手机权限不支持复制功能",
        });
        console.log("该浏览器不支持自动复制", e);
        // 释放内存
        clipboard.destroy();
      });
    },
     handleDetail(id) {
      this.$router.push(`/orderIndex/orderDetail/${id}`);
    },
  },
};
</script>
<style lang='less' scoped>
.orderPage {
  padding-top: 40px;
  .search_wrap {
    width: 660px;
    height: 80px;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 45px;
    margin: auto;
    background: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
    margin-bottom: 25px;
    /deep/ .van-cell {
      padding: 0;
      background: none;
      flex-shrink: 0;
      border: none;
      flex: 1;
    }
    /deep/ .van-field__control {
      text-align: center;
    }
    .search_btn {
      flex-shrink: 0;
      width: 70px;
      .iconfont {
        font-size: 40px;
        color: #d6d0d1;
      }
    }
  }
  .select_wrap {
    width: 660px;
    margin: auto;
    .select_item {
      margin-top: 20px;
      height: 80px;
      border-bottom: 1px dashed #2c2b2b;
      font-size: 30px;
      color: #333333;
      padding: 0 14px;
      .icon-toTop {
        transform: rotate(180deg);
        font-size: 20px;
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
      width: 280px;
      box-sizing: border-box;
      text-align: center;
      padding: 0 30px 0 15px;
    }
    /deep/ .van-dropdown-menu__title::after {
      right: 20px;
      border-color: transparent transparent #c4c5c6 #c4c5c6;
    }
  }
  .radio_wrap {
    font-size: 24px;
    color: #1e1e1e;
    margin: 25px auto;
    span {
      margin-left: 16px;
    }
  }
  .clear_condition {
    width: 200px;
    height: 60px;
    background: #ffffff;
    border: 3px solid #096f70;
    border-radius: 35px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
    text-align: center;
    line-height: 60px;
  }
  .order_wrap {
    margin-top: 25px;
    height: 67vh;
    overflow-y: scroll;
    .list {
      .item {
        width: 660px;
        min-height: 700px;
        background: #ffffff;
        border: 6px solid #e6e6e6;
        border-radius: 40px;
        margin: 0 auto 30px;
        padding: 52px 44px 0;
        box-sizing: border-box;
        font-size: 28px;
        color: #040000;
        .block_one {
          font-size: 30px;
          margin-bottom: 45px;
          .column {
            &:nth-child(2n) {
              margin: 10px 0;
            }
            .label {
              width: 140px;
            }
            .con {
              color: #ff0000;
            }
          }
        }
        .block_two {
          // margin-bottom: 99px;
          font-size: 28px;
          .column {
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        
        .column {
          align-items: flex-start;
          &:nth-child(2n) {
            margin: 26px 0;
          }
          .left {
            align-items: flex-start;
            .con {
              width: 320px;
              flex-shrink: 0;
            }
          }
          .label {
            white-space: nowrap;
            width: 180px;
            flex-shrink: 0;
          }
          .con {
            word-wrap: break-word;
            flex-shrink: 0;
            width: 380px;
            span {
              margin-left: 10px;
            }
          }
          .iconfont {
            font-size: 30px;
          }
        }
      }
    }
  }
  /deep/ .van-popup--bottom {
    bottom: 80px;
  }
}
</style>